import citiesLibrary from './libraries/cities'
import randomInt from 'random-int'

/**
 * @returns {*}
 */
const city = () => {
  let number = randomInt( 0, citiesLibrary.length - 1 )

  return citiesLibrary[ number ]
}

export default city



// WEBPACK FOOTER //
// ./src/city.js